import React, { useState } from 'react';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { useFormik } from 'formik';
import { Typography } from "@mui/material";
import { useOutletContext, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import useToast from '../../../helpers/useToast';
import * as Yup from 'yup';
import useEncryption from '../../../services/useEncryption';
import { addTeamApi } from '../../../api/adminApi/adminApi';
import { addTeamSchema } from '../../../services/formValidator/userValidator';
import { createAuditLogs } from '../../../api/providerApi/providerApi';
import useHeaders from '../../../helpers/useHeaders';
import { useSelector } from 'react-redux';
import { selectAuth } from '../../../redux/slice/authSlice';

const AdminAddTeamModal = ({ open, handleClose, setUpdate }) => {
  const { encryptData, decryptData } = useEncryption();
  const [photo, setPhoto] = useState(null);
  const [photoError, setPhotoError] = useState('');
  const { id } = useParams();
  const toastOption = useToast();
  const headers = useHeaders();
  const { role } = useSelector(selectAuth);
  //   const decryptedId = decryptData(decodeURIComponent(providerID));
  // const [loading, setLoading] = useOutletContext();

  // const validateImage = (file) => {
  //   console.log("fielsi--val--",file)
  //   return new Promise((resolve, reject) => {
  //     if (file.size > 1024 * 1024) {
  //       reject('File size should not be more than 1 MB');
  //       return;
  //     }
  //     const img = new Image();
  //     const reader = new FileReader();

  //     reader.onload = () => {
  //       img.src = reader.result;
  //     };

  //     img.onload = () => {
  //       if (img.width !== 512 || img.height !== 512) {
  //         reject('Image dimensions should be 512x512 px');
  //       } else {
  //         resolve();
  //       }
  //     };

  //     img.onerror = () => {
  //       reject('Error reading image');
  //     };

  //     reader.readAsDataURL(file);
  //   });
  // };

  // const handleImageChange = async (event) => {
  //   const file = event.target.files[0];
  //   if (file) {
  //     try {
  //       await validateImage(file);
  //       const reader = new FileReader();
  //       reader.onloadend = () => {
  //         setPhoto(reader.result);
  //         formik.setFieldValue('photo', file);
  //         setPhotoError(''); 
  //       };
  //       reader.readAsDataURL(file);
  //     } catch (error) {
  //       setPhotoError(error);
  //       formik.setFieldValue('photo', null);
  //     }
  //   }
  // };

  const handleImageChange = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const img = new Image();
    img.src = URL.createObjectURL(file);

    img.onload = () => {
      const size = 512;
      const canvas = document.createElement('canvas');
      canvas.width = size;
      canvas.height = size;
      const ctx = canvas.getContext('2d');

      const minSize = Math.min(img.width, img.height);
      const sx = (img.width - minSize) / 2;
      const sy = (img.height - minSize) / 2;

      ctx.drawImage(img, sx, sy, minSize, minSize, 0, 0, size, size);

      canvas.toBlob((blob) => {
        if (blob) {
          const croppedFile = new File([blob], file.name.replace(/\.\w+$/, '.jpeg'), {
            type: 'image/jpeg',
            lastModified: Date.now(),
          });

          const reader = new FileReader();
          reader.onloadend = () => {
            setPhoto(reader.result); // Preview
            formik.setFieldValue('photo', croppedFile); // Form data
            setPhotoError('');
          };
          reader.readAsDataURL(croppedFile);
        }
      }, 'image/jpeg', 0.7);
    };

    img.onerror = () => {
      setPhotoError('Invalid image file.');
      formik.setFieldValue('photo', null);
    };
  };

  const triggerFileUpload = () => {
    document.getElementById('file-upload').click();
  };

  const formik = useFormik({
    initialValues: {
      firstName: '',
      lastName: '',
      email: '',
      phoneNumber: '',
      userType: '',
      doctorTitle: '',
      photo: null,
    },
    validationSchema: addTeamSchema,
    onSubmit: async (values, { resetForm }) => {
      // setLoading(true);
      const formData = new FormData();

      formData.append('firstName', values.firstName);
      formData.append('lastName', values.lastName);
      formData.append('email', values.email);
      formData.append('phoneNumber', values.phoneNumber);
      formData.append('role', values.userType);
      formData.append('doctorTitle', values.doctorTitle);

      if (values.photo) {
        formData.append('photo', values.photo);
      }

      try {
        let response = await addTeamApi(id, formData);

        // setLoading(false);
        handleClose();
        resetForm();
        setUpdate(prev => !prev);
        let obj = {
          event : `${role} has added teams user ${values.firstName} ${values.lastName} .`
        }
        await createAuditLogs({ data: encryptData(obj)}, headers);

        toast.success(response.data.message, toastOption);
      } catch (error) {

        if (error.response) {
          toast.error(error.response.data.message || "An error occurred.", toastOption);
        } else {
          toast.error("Network error. Please try again.", toastOption);
        }
      }
    }
  });

  return (
    <Dialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={open}
    >
      <div className="d-flex align-items-center justify-content-between">
        <DialogTitle id="customized-dialog-title">Add Team Member</DialogTitle>
        <IconButton aria-label="close" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </div>
      <DialogContent dividers>
        <div className="uploadprofileimg">
          <div>
            <div className="profile-pic-container">
              <img
                src={photo ? photo : "/profile.svg"}
                alt="Profile"
                className="profile-pic"
                style={{ width: '150px', height: '150px', borderRadius: '50%' }}
              />
            </div>
            <input
              type="file"
              id="file-upload"
              accept="image/*"
              style={{ display: 'none' }}
              onChange={handleImageChange}
            />
            <button onClick={triggerFileUpload} className="upload-button">
              Upload Image
            </button>
            {photoError && <div style={{ color: 'red' }}>{photoError}</div>}
          </div>
          <div className="textsides">
            <h6>Update Profile Image</h6>
            <p>The Image should be 512*512 px and not bigger than 1 MB</p>
          </div>
        </div>

        <form onSubmit={formik.handleSubmit} className="sectionalForms">
          <div className="row">
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="First Name"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="firstName"
                  value={formik.values.firstName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.firstName && Boolean(formik.errors.firstName)}
                  helperText={formik.touched.firstName && formik.errors.firstName}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Last Name"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                  helperText={formik.touched.lastName && formik.errors.lastName}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Email"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="email"
                  value={formik.values.email}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.email && Boolean(formik.errors.email)}
                  helperText={formik.touched.email && formik.errors.email}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <TextField
                  label="Phone Number"
                  className="w-100"
                  variant="outlined"
                  size="small"
                  name="phoneNumber"
                  value={formik.values.phoneNumber}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  error={formik.touched.phoneNumber && Boolean(formik.errors.phoneNumber)}
                  helperText={formik.touched.phoneNumber && formik.errors.phoneNumber}
                />
              </div>
            </div>
            <div className="col-lg-6 col-sm-12">
              <div className="formdesign">
                <FormControl fullWidth size="small" error={formik.touched.userType && Boolean(formik.errors.userType)}>
                  <InputLabel id="userType-label">User Type</InputLabel>
                  <Select
                    labelId="userType-label"
                    id="userType"
                    name="userType"
                    value={formik.values.userType}
                    label="User Type"
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.userType && Boolean(formik.errors.userType)}
                  >
                    <MenuItem value="doctor">Doctor</MenuItem>
                    <MenuItem value="staff">Staff</MenuItem>
                    <MenuItem value="location">Admin</MenuItem>
                  </Select>

                  {formik.touched.userType && formik.errors.userType && (
                    <Typography variant="caption" color="error" style={{ marginLeft: "15px", marginTop: "4px" }}>
                      {formik.errors.userType}
                    </Typography>
                  )}
                </FormControl>

              </div>
            </div>
            {formik.values.userType === "doctor" && (
              <div className="col-lg-6 col-sm-12">
                <div className="formdesign">
                  <TextField
                    label="Doctor’s Title"
                    className="w-100"
                    variant="outlined"
                    size="small"
                    name="doctorTitle"
                    value={formik.values.doctorTitle}
                    onChange={formik.handleChange}
                    onBlur={formik.handleBlur}
                    error={formik.touched.doctorTitle && Boolean(formik.errors.doctorTitle)}
                    helperText={formik.touched.doctorTitle && formik.errors.doctorTitle}
                  />
                </div>
              </div>
            )}
          </div>
        </form>
      </DialogContent>
      <DialogActions>
        <div className="text-end modalactions">
          <button className="btn btn-blacked outline me-2" onClick={handleClose}>Cancel</button>
          <button className="btn btn-blacked" onClick={formik.handleSubmit}>Submit</button>
        </div>
      </DialogActions>
    </Dialog>
  );
};

export default AdminAddTeamModal;
